export const EMAIL = 'email';
export const PHONE = 'phone';
export const FACEBOOK = 'facebook';



// WEBPACK FOOTER //
// ./app/constants/signupAuthType.js